import { useState } from 'react';
import { api, formatDate } from '../lib/api.js';
import { StudioMark, useBranding } from '../lib/branding.jsx';
import { IconLock } from '../lib/icons.jsx';

/**
 * Password gate. No accounts — the link plus this password is the whole auth
 * story. Styled as a quiet, centred card on paper so the first impression is
 * calm rather than a login form.
 */
export default function Unlock({ meta, slug, coverUrl, onUnlocked }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const { branding } = useBranding();

  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      await api.post(`/api/gallery/${slug}/unlock`, { password });
      onUnlocked();
    } catch (err) {
      setError(err.message);
      setBusy(false);
    }
  }

  return (
    <div className="unlock-screen">
      {coverUrl && <img className="unlock-bg" src={coverUrl} alt="" aria-hidden />}
      <div className="unlock-veil" />
      <form className="unlock-card" onSubmit={submit}>
        <div className="unlock-mark">
          <StudioMark />
        </div>
        {meta.hero_kicker !== '' && (
          <span className="label" style={{ marginBottom: '0.9rem' }}>{meta.hero_kicker || 'The Wedding of'}</span>
        )}
        <h1 className="serif unlock-name">{meta.client_name}</h1>
        {meta.wedding_date && <p className="unlock-date">{formatDate(meta.wedding_date)}</p>}

        <div className="unlock-divider" />

        <div className="unlock-lock">
          <IconLock />
        </div>
        <label htmlFor="pw" style={{ textAlign: 'center' }}>Enter your gallery password</label>
        <input
          id="pw"
          type="password"
          autoFocus
          autoComplete="off"
          autoCapitalize="none"
          spellCheck="false"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={{ textAlign: 'center', letterSpacing: '0.1em' }}
        />
        {error && <div className="error" style={{ marginTop: '0.75rem' }}>{error}</div>}
        <button className="primary" disabled={busy || !password} style={{ width: '100%', marginTop: '0.85rem' }}>
          {busy ? 'Opening…' : 'View gallery'}
        </button>
        {branding?.contact_email && (
          <p className="tiny" style={{ marginTop: '1rem', marginBottom: 0 }}>
            Lost your password? <a href={`mailto:${branding.contact_email}`}>{branding.contact_email}</a>
          </p>
        )}
      </form>
    </div>
  );
}
